import styled from 'styled-components';

import {
  VARIANT_MODAL_CONTENT_GAP,
  VARIANT_MODAL_DROPDOWN_GAP,
  VARIANT_MODAL_DROPDOWN_WIDTH,
  VARIANT_MODAL_INPUT_WIDTH,
  VARIANT_MODAL_LINKED_STORE_ICON_GAP,
} from './constants';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${VARIANT_MODAL_CONTENT_GAP};
`;

export const InputsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${VARIANT_MODAL_CONTENT_GAP};
`;

export const InputContainer = styled.div`
  width: ${VARIANT_MODAL_INPUT_WIDTH};

  > div {
    justify-content: flex-start;
  }
`;

export const DropdownsContainer = styled.div`
  display: flex;
  gap: ${VARIANT_MODAL_DROPDOWN_GAP};
`;

export const DropdownContainer = styled.div`
  width: ${VARIANT_MODAL_DROPDOWN_WIDTH};
`;

export const StoreDropdownItem = styled.div`
  align-items: center;
  display: flex;
  justify-content: space-between;
  width: 100%;
`;

export const StoreName = styled.span`
  color: ${({ theme, isDisabled }) => (isDisabled ? theme.colors.greys.dark : theme.colors.black)};
  font: ${({ theme }) => theme.fonts.textSmall};
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const LinkedStoreIconContainer = styled.div`
  align-items: center;
  display: flex;
  flex-shrink: 0;
  gap: ${VARIANT_MODAL_LINKED_STORE_ICON_GAP};
  margin-left: 8px;
`;

export const LinkedStoreIcon = styled.img`
  height: 16px;
  width: 16px;
`;
